import React, { createContext } from 'react';
import { useAuthHelper } from '../../components/AuthContextProvider';
import * as UserManager from '../domain/user-manager';
import * as LocationManager from '../domain/location-manager';
import { Data, makeLoadedData } from '../../types';
import { dataFromDataset, useData } from './DataProviderCache';

import { OrganizationData } from '../../types/site';

type ContextState = Data<{
    userRoles: Data<{
        roles: Array<{
            roleId: string;
            siteId: string[];
            roleName: string;
            roleDescription: string;
            operation?: string[] | undefined;
        }>;
    }>;
    userLocation: Data<OrganizationData[]>;
}>;
export const Context = createContext<ContextState | null>(null);

function useUserRoleLocationData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useUserRoleLocationData must be used within a UserRoleLocationProvider');
    }
    return contextState;
}
const UserRoleLocationProvider: React.FC<{ userId: string; organizationId: string }> = (props) => {
    const authHelper = useAuthHelper();
    
    const roleData = useData({
        cacheKey: 'user-role',
        id: props.userId,
        dataFn: React.useCallback(() => UserManager.getExistingUserRoles(authHelper, props.userId), [
            props.userId,
            authHelper,
        ]),
    });
    const userRoles = dataFromDataset(roleData.dataset);

    const OrganizationInfo = useData({
        cacheKey: 'user-location',
        id: props.userId,
        dataFn: React.useCallback(
            () => LocationManager.getExistingUserLocation(authHelper, props.organizationId,props.userId),
            [authHelper, props.organizationId,props.userId]
        ),
    });
    const userLocation = dataFromDataset(OrganizationInfo.dataset);
    const result = makeLoadedData({ userRoles, userLocation });
    return <Context.Provider value={result}>{props.children}</Context.Provider>;
};
const TestUserRoleLocationProvider: React.FC<{
    value: ContextState;
}> = (props) => <Context.Provider value={props.value}>{props.children}</Context.Provider>;

export { UserRoleLocationProvider, TestUserRoleLocationProvider, useUserRoleLocationData };
